import useCognito from "../useCognito";

const useRecovery = () => {
    const { cognitoAdminRecovery, cognitoAdminConfirmRecovery, cognitoAdminConfimar } = useCognito();

    const sendAdminRecovery = async (username) => {
        try{
            const response = await cognitoAdminRecovery(username);

            return { exitoso: response.exitoso, data: response.data };
        } catch (error) {
            return { exitoso: false, data: error?.response?.data?.data };
        }
    };

    const confirmAdminRecovery = async (username, password, code) => {
        try {
            const response = await cognitoAdminConfirmRecovery(username, password, code);
            return { exitoso: true, data: response.data };
        } catch (error) {
            return { exitoso: false, data: error?.response?.data?.data };
        }
    };

    const confirmAdminSignup = async (username, password, code) => {
        try {
            const response = await cognitoAdminConfimar(username, password, code);
            return { exitoso: true, data: response.data };
        } catch (error) {
            return { exitoso: false, data: error?.response?.data?.data }
        }
    };

    return {
        sendAdminRecovery,
        confirmAdminRecovery,
        confirmAdminSignup
    };
};

export default useRecovery;